/**
 * In a frame with sandbox="allow-scripts" (no allow-same-origin), localStorage,
 * sessionStorage and document.cookie throw a SecurityError. Widget and page
 * scripts often use them, and on the live page they work, so previews get
 * in-memory versions instead (only where the real ones throw). Used by the AI
 * paste preview and by the editor's section preview.
 */
export const PREVIEW_STORAGE_SHIM = `(function () {
  function memoryStorage() {
    var data = {};
    var api = {
      getItem: function (k) { k = String(k); return Object.prototype.hasOwnProperty.call(data, k) ? data[k] : null; },
      setItem: function (k, v) { data[String(k)] = String(v); },
      removeItem: function (k) { delete data[String(k)]; },
      clear: function () { data = {}; },
      key: function (i) { var keys = Object.keys(data); return i >= 0 && i < keys.length ? keys[i] : null; }
    };
    Object.defineProperty(api, 'length', { get: function () { return Object.keys(data).length; } });
    return api;
  }
  ['localStorage', 'sessionStorage'].forEach(function (name) {
    try { window[name].getItem('__gx'); } catch (e) {
      try { Object.defineProperty(window, name, { value: memoryStorage(), configurable: true }); } catch (e2) { /* leave as is */ }
    }
  });
  try { void document.cookie; } catch (e) {
    var jar = {};
    try {
      Object.defineProperty(document, 'cookie', {
        configurable: true,
        get: function () { return Object.keys(jar).map(function (k) { return k + '=' + jar[k]; }).join('; '); },
        set: function (v) {
          var parts = String(v).split(';');
          var pair = parts[0];
          var i = pair.indexOf('=');
          if (i < 1) { return; }
          var name = pair.slice(0, i).trim();
          var value = pair.slice(i + 1).trim();
          var expired = parts.slice(1).some(function (p) {
            var kv = p.split('=');
            var key = (kv[0] || '').trim().toLowerCase();
            var val = (kv.slice(1).join('=') || '').trim();
            return (key === 'max-age' && Number(val) <= 0) || (key === 'expires' && Date.parse(val) <= Date.now());
          });
          if (expired) { delete jar[name]; } else { jar[name] = value; }
        }
      });
    } catch (e2) { /* leave as is */ }
  }
})();`;
